import { memo, useEffect, useState } from 'react';
import moment from 'moment/moment';
import { Row, Col, Container } from 'react-bootstrap';
import ZeroStates from '../../ZeroStates';
import { useSelector } from 'react-redux';
import { BzLoader } from '../../../components';


const Broker = ({ arrBroker, searchText }) => { //  Hari K :06-11-2023: BT-109371 message hub -receiving seach text prop

    const [arrBrokerData, setArrBrokerData] = useState(); // Hari K :06-11-2023, BT-109371 message hub - maintained local state for search functionality

    const isBrokerAPIFailed = useSelector(state => state.messages.isBrokerAPIFailed); //  Hari K :06-11-2023: BT-109371 message hub -receving isBrokerAPIFailed redux state

    const IsBrokerAPIPendingStatus = useSelector(state => state.messages.IsBrokerAPIPendingStatus);

    // Hari K:06-11-2023, BT-109371 message hub - search functionality-start
    useEffect(() => {
        if (searchText?.length > 0) {
            const filteredArrBrokerData = arrBroker?.filter((each) => each?.subject?.toLowerCase()?.includes(searchText?.toLowerCase()));
            setArrBrokerData(filteredArrBrokerData);
        } else {
            setArrBrokerData(arrBroker);
        }
    }, [arrBroker, searchText]);
    // Hari K:06-11-2023, BT-109371 message hub - search functionality-end

    return (

        <Container fluid className='p-0'>
            {arrBroker?.length ?
                <>
                    {arrBrokerData?.length > 0 ?
                        arrBrokerData?.map((each, i) => (
                            <Row className='g-0 justify-content-evenly bdr-btm p-2'>
                                <Col md='auto'>
                                    <div className='icon-36 icon-exchange-bt me-2'></div>
                                </Col>
                                <Col md={10} key={i}>
                                    <div className='font-medium font-size1 color-text mb-1'>{each.subject} {each?.subject?<span>:</span>:""}  {each.message}</div>
                                    <div className='font-regular font-size1 color-subtext'>{moment(each?.sendMsgTime, 'YYYY-MM-DD HH:mm:ss').format("DD MMM' YY h:mm A")}</div>
                                </Col>
                            </Row>
                        )) : searchText?.length ?
                            // Ameersha N :15-11-2023 SAT-109371 message hub - issue - No data found after search - Start
                            <div className='zero-state-alerts zero-state-alerts-xl'>
                                <div className='icon-64 icon-nodata mrgauto mb-3'></div>
                                <div className='font-medium font-size4 color-text mb-1'>No matches found</div>
                                <div className='font-regular font-size2 color-nodata'>Try adjusting your search to find what you are looking for</div>
                            </div>
                            // Ameersha N :15-11-2023 SAT-109371 message hub - issue - No data found after search - End
                            : null
                    }
                </> : (IsBrokerAPIPendingStatus && arrBroker?.length <= 0) ?
                    <div className='zero-state-alerts zero-state-alerts-xl'>
                        <BzLoader spinner={IsBrokerAPIPendingStatus} spinnerContent={"Fetching Details"} />
                    </div>
                    : (arrBroker?.length <= 0 && isBrokerAPIFailed) ?     // Hari K:06-11-2023 zero states cahnges
                        <div className='zero-state-alerts zero-state-alerts-xl'>
                            {/* // Ameersha N :15-11-2023 SAT-109371 message hub - issue - changed subText to  "Currently there are no notifications" */}
                            <ZeroStates subText="Currently there are no notifications" isButtonShowing={false} icon='icon-64 icon-nodata mb-3 mrgauto' />
                        </div> : null
            }
        </Container>

    );
};

export default memo(Broker);